import { CSC_PAYMENTS_HOST } from "@/services/Configuration"
import { error, log } from "@/services/Log"
import CSC from "@csc/csc-sdk"
import { getSavedInstrumentsCredentials } from "../cscPaymentsServices"

const getPaymentMethodFromTransactionId = async (paymentId: string = '', paymentMethod: string = '', defaultCurrencyCode: string = '', orderTotal: string = '') => {
  log(`getPaymentMethodFromTransactionId Start`, {
    paymentId,
    paymentMethod,
    defaultCurrencyCode,
    orderTotal,
  })
  try {

    const credentials = await getSavedInstrumentsCredentials()
    const identity = credentials.identitySourceId

    const CSCPaymentPortal = CSC.Payments({ credentials, host: CSC_PAYMENTS_HOST })
    let paymentFromOrder = await CSCPaymentPortal.getPayment({
      identity,
      paymentId,
    })

    let method = await CSCPaymentPortal.getPaymentMethod({
      identity,
      paymentMethodId: paymentFromOrder.paymentMethodId
    })

    log(`Payment method retrieved`)
    const total = paymentFromOrder?.totalAmount || ''
    const last4 = method?.meta?.last4 || ''
    const type = method?.meta?.type || ''
    if (!!total && !!last4 && !!type) {
      return {
        "method": paymentMethod,
        "amount": `${defaultCurrencyCode} $${parseFloat(`${total}`).toFixed(2)}`,
        type,
        "mask": `************${last4}`
      }
    }
  } catch (err) {
    error(`Failed to retrieve customer payment for the order: ${err}`)
  }
  log(`Returning transaction details for a guest `)
  return {
    "method": paymentMethod,
    "amount": `${defaultCurrencyCode} $${parseFloat(orderTotal).toFixed(2)}`,
    "type": "",
    "mask": ""
  }

}

export default getPaymentMethodFromTransactionId